import { observer } from 'mobx-react-lite';
import IncidentList from '../../MonitorsPage/IncidentList';

interface IIncidentsTabProps {
	tableId: string;
}

function IncidentsTab({ tableId }: IIncidentsTabProps) {
	return (
		<IncidentList
			defaultRequiredSearchParams={{
				target_id: tableId,
			}}
		/>
	);
}

const IncidentsTabWithObserver = observer(IncidentsTab);
export default IncidentsTabWithObserver;
